import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import ReceiptListData from "../../components/ReceiptApplication/ReceiptList";

const ReceiptApplication =() => {
  return(
    <>
     <Breadcrumb />
      <Typography>
         <ReceiptListData/>
      </Typography>
    </>
  );
};
export default ReceiptApplication;